<template>
    <div>
      AlternativesView
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'AlternativesView',
  
    components: {
    },
  
    data() {
      return {
      }
    },
  
    methods: {
    }
  };
  </script>
  